import { Component, DestroyRef, Inject, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { timer } from 'rxjs';
import { MailProvider, mailboxSearchQuery, mailProviderOf } from "../../models";

export interface CodeEmailHelpModalData {
  /** The address the sign-up code went to. */
  email: string;
}

/**
 * The long answer to "I cannot find the code email", opened from the info
 * button on the enter-code screen.
 *
 * The steps are in the order that solves the most cases first: a new code and
 * a fresh mailbox, then the folders the email lands in, then the search for the
 * word the email carries. The folder names follow the address's mail service.
 */
@Component({
  selector: 'cpf-code-email-help-modal',
  templateUrl: './code-email-help-modal.component.html',
  styleUrls: ['./code-email-help-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CodeEmailHelpModalComponent {
  readonly provider: MailProvider;
  readonly searchQuery: string;
  copied = false;

  private destroyRef = inject(DestroyRef);

  constructor(public dialogRef: MatDialogRef<CodeEmailHelpModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: CodeEmailHelpModalData) {
    this.provider = mailProviderOf(data.email);
    this.searchQuery = mailboxSearchQuery(this.provider);
  }

  onCopied(): void {
    this.copied = true;
    timer(2000).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.copied = false;
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
